import React, {useEffect, useState} from 'react';

import {AppContext} from './utils/appContext';

import {getCurrentWebsite} from "./utils/helpers";
import {ToastContainer} from "react-toastify";
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n';
import moment from 'moment-timezone';
import {IAppContext, IComplaint, IHelpForm} from "./interfaces/assistanceContext";
import ReCAPTCHA from 'react-google-recaptcha';
import i18next from "i18next";

declare global {
    interface Window {
        current_lang: string;
    }
}

const complaintEmpty: IComplaint = {
    GuestFirstname: '',
    GuestName: '',
    Email: '',
    ReservationNumber: '',
    Note: '',
    Attachment: [],
    Reasons: '',
    GuestArrival: null,
    GuestDeparture: null,
    Property: '',
}

const helpFormEmpty: IHelpForm = {
    GuestFirstname: '',
    GuestName: '',
    Email: '',
    Argument: '',
    ReservationNumber: '',
    RoomNumber: '',
    Note: '',
    Attachment: [],
    GuestArrival: null,
    GuestDeparture: null,
    CheckboxIntervention: false,
}

const Main = (props: { children: React.ReactNode; }) => {

    const [website, setWebsite] = useState(getCurrentWebsite());
    const [language, setLanguage] = useState(i18next.language);
    const [complaint, setComplaint] = useState<IComplaint>(complaintEmpty);
    const [helpForm, setHelpForm] = useState<IHelpForm>(helpFormEmpty);
    const [helpReason, setHelpReason] = useState<number>(0);

    useEffect(() => {
        //i18n.changeLanguage(language).then((r: any) => console.log('Lang changed', language, r));
        moment.updateLocale(language, {
            week: {
                dow: 1
            }
        });
    }, [i18next.language]);

    const recaptchaRef = React.useRef({} as ReCAPTCHA);

    const getTokenRecaptcha = async () => {
		return recaptchaRef.current.executeAsync();
	}


    const value: IAppContext = {
        website,
        setWebsite,
        language,
        setLanguage,
        complaint,
        setComplaint,
        helpForm,
        setHelpForm,
        helpReason,
        setHelpReason,
        getTokenRecaptcha
    };

    return <AppContext.Provider value={value}>
        <I18nextProvider i18n={i18n}>
            <ReCAPTCHA
                sitekey="6LcB5JQpAAAAAMXG8BUqeHGI07MFoB2wPKl3U2Ru"
                size={'invisible'}
                ref={recaptchaRef}
                hl={language}
            />
            <main>{props.children}</main>
            <ToastContainer/>
        </I18nextProvider>
    </AppContext.Provider>
};

export default Main;
